import React, {useState, useEffect} from 'react'
import { DateTime } from 'luxon'
import './KabaddiScore.scss'
import { FaRegClock } from 'react-icons/fa'
import KabaddiTeamScores from '../components/KabaddiTeamScores'

export default function KabaddiScore({ event, teams, match_update, scoreboard, teamFontSize }) {

    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    })

    useEffect(() => {
        const timeout = setTimeout(() => {
            setTimeLeft(calculateTimeLeft())
        }, 1000)

        return () => clearTimeout(timeout);
    })

    function calculateTimeLeft () {
        const { start_datetime } = match_update || {};

        let timeUntilStart = {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0
        }

        if (start_datetime) {
            const startDateTime = DateTime.fromISO(start_datetime);
    
            timeUntilStart = startDateTime.diffNow(['days', 'hours', 'minutes', 'seconds']).toObject();

            timeUntilStart.seconds = Number(timeUntilStart.seconds.toFixed(0))
        }

        return timeUntilStart
    }
    
    function getValueFromScoreboard(name) {
        if (!scoreboard) {
            return null
        }

        const found = scoreboard.find(i => i.name === name)

        if (found){
            return found.value
        }

        return null
    }

    const { event_status } = event;

    const raidA = {
        number: getValueFromScoreboard('Raid.A'),
        team: getValueFromScoreboard('Raid.A.Team'),
        outcome: getValueFromScoreboard('Raid.A.Outcome')
    }

    const raidB = {
        number: getValueFromScoreboard('Raid.B'),
        team: getValueFromScoreboard('Raid.B.Team'),
        outcome: getValueFromScoreboard('Raid.B.Outcome')
    }

    const raidC = {
        number: getValueFromScoreboard('Raid.C'),
        team: getValueFromScoreboard('Raid.C.Team'),
        outcome: getValueFromScoreboard('Raid.C.Outcome')
    }

    const raidD = {
        number: getValueFromScoreboard('Raid.D'),
        team: getValueFromScoreboard('Raid.D.Team'),
        outcome: getValueFromScoreboard('Raid.D.Outcome')
    }

    const raidE = {
        number: getValueFromScoreboard('Raid.E'),
        team: getValueFromScoreboard('Raid.E.Team'),
        outcome: getValueFromScoreboard('Raid.E.Outcome')
    }

    if (! scoreboard && event_status === 'MATCH_SCHEDULED') {
        return (
            <div className="scheduled">
                <FaRegClock size={30} style={{ marginRight: '10px' }}/>
                <div className="clock-wrapper">
                    Match is scheduled to start in: 
                    <div className="clock">
                        {timeLeft.days + ':' + timeLeft.hours + ':' + timeLeft.minutes + ':' + timeLeft.seconds}
                    </div>
                </div>
            </div>
        )
    }

    const scoreline = getValueFromScoreboard('Scoreline')
    const clock = Number(getValueFromScoreboard('Clock'))

    return (
        
        <div className="kabaddi-score">
            <KabaddiTeamScores
                scoreboard={scoreboard}
                teams={teams}
                teamFontSize={teamFontSize}
            />

            <div className="clock-and-scoreline">
                <div className="clock">
                    <FaRegClock size={25} style={{ marginBottom: '5px' }}/> 
                    <div>{clock} mins</div>
                </div>
                <div className="scoreline">{ scoreline }</div>
            </div>
            
            <div className="raids-table">
                <div className="raids-table-header">
                    <div style={{ textAlign: 'center' }}>Raid</div>
                    <div>Team</div>
                    <div>Outcome</div>
                </div>
                <div className="raids-table-row">
                    <div style={{ textAlign: 'center' }}>{raidA.number}</div>
                    <div>{raidA.team}</div>
                    <div>{raidA.outcome}</div>
                </div>
                <div className="raids-table-row">
                    <div style={{ textAlign: 'center' }}>{raidB.number}</div>
                    <div>{raidB.team}</div>
                    <div>{raidB.outcome}</div>
                </div>
                <div className="raids-table-row">
                    <div style={{ textAlign: 'center' }}>{raidC.number}</div>
                    <div>{raidC.team}</div>
                    <div>{raidC.outcome}</div>
                </div>
                <div className="raids-table-row">
                    <div style={{ textAlign: 'center' }}>{raidD.number}</div>
                    <div>{raidD.team}</div>
                    <div>{raidD.outcome}</div>
                </div>
                <div className="raids-table-row">
                    <div style={{ textAlign: 'center' }}>{raidE.number}</div>
                    <div>{raidE.team}</div>
                    <div>{raidE.outcome}</div>
                </div>
            </div>
        </div>
    )
}
